module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/personnel-details/Update-Personnel-Details/update-personnel-grid/update-personnel-grid.component.css
// module id = ./src/app/pages/functions/personnel-details/Update-Personnel-Details/update-personnel-grid/update-personnel-grid.component.css
// module chunks = main